module.exports = __webpack_public_path__ + "static/media/outBtn.8e26f460.svg";